import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
import { ICerere } from 'src/app/components/cereri/cereri.interface';
import { IAppointment } from 'src/app/components/programari/programari.interface';

const TIMEZONE = 'Europe/Bucharest';

@Component({
    selector: 'app-appointment',
    templateUrl: './appointment.component.html',
    styleUrls: ['./appointment.component.scss']
})
export class AppointmentComponent {
    // _appointment: IAppointment | null = null;

    @Input() appointment!: IAppointment;
    @Input() cerere!: ICerere;
    @Input() editing = false;
    @Input() readonly = true;

    @Output() appointmentChange: EventEmitter<any> = new EventEmitter();

    isLoading = false;

    todayMoment = moment().startOf('day');
    endOfYearMoment = moment().endOf('year');
    date = moment(this.todayMoment).toDate();
    time = '';

    slots: string[] = [];
    sarbatoriLegale: any[] = [];
    fullDaysForCurrentYear: any[] = [];

    calendarFilter: (d: Date | null) => boolean = this.calendarFilterAppointment;

    ngOnInit() {
        this.getRestrictedDates();
        this.getAvailableSlots();
    }

    renderStatus(status: string) {
        if (status === 'confirmed') {
            return 'Confirmată';
        }

        if (status === 'rejected') {
            return 'Anulată';
        }

        if (status === 'pending') {
            return 'În așteptare';
        }

        return '';
    }

    cancel() { }

    confirm() { }

    modify() { }

    getAvailableSlots() {
        // this.isLoading = true;
        // this.slotService.getAvailableSlots(this.moduleName, this.date.format(), this.appointment.id_locatie)
        //     .subscribe(

        //     )
    }

    // addInitialSlotIfDateIsInitialDate() {
    //     if (moment(this.date).tz(TIMEZONE).format('YYYY-MM-DD') === moment(this.appointment.date).tz(TIMEZONE).format('YYYY-MM-DD')) {
    //       const initialSlot = this.appointment.time_from;

    //       if (this.slots.indexOf(initialSlot) === -1) {
    //         this.slots.push(initialSlot);
    //         this.slots.sort();
    //       }
    //     }
    // }

    getRestrictedDates() {
        this.getSarbatoriLegale();
        this.getFullDaysForCurrentYear();
    }

    getSarbatoriLegale() { }

    getFullDaysForCurrentYear() { }

    calendarFilterAppointment(d: Date | null): boolean {
        const date = moment(d) || moment().startOf('day');

        // Prevent Saturday and Sunday from being selected.
        // const isNotWeekend = day !== 0 && day !== 6;
        let isNotRestricted = true;
        return isNotRestricted;

        // Prevent restricted dates from being selected
        if (this.sarbatoriLegale.length) {
            const restrictedMoments = this.sarbatoriLegale.map((rd) => moment(rd.date).tz(TIMEZONE));
            isNotRestricted = !restrictedMoments.some((rm) => rm.isSame(date));
        }

        if (this.fullDaysForCurrentYear.length && isNotRestricted) {
            isNotRestricted = this.fullDaysForCurrentYear.indexOf(moment(date).tz(TIMEZONE).format('YYYY-MM-DD')) === -1;
        }

        if (!isNotRestricted) console.log(moment(date).tz(TIMEZONE).format('YYYY-MM-DD'));

        return isNotRestricted;
    }
}
